var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "helpSupport",
    transform: "translate(-552 -528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5334",
    "data-name": "Group 5334"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 128,
    height: 128,
    transform: "translate(552 528)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(5996.837 -7798.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M275.825,235.076a40.874,40.874,0,0,0-22.416-36.4,55.583,55.583,0,0,1-54.73,54.73A40.762,40.762,0,0,0,255.81,270.16l19.837,5.487L270.16,255.81a40.6,40.6,0,0,0,5.665-20.734Zm0,0",
    transform: "translate(-5593.63 8177.986)",
    fill: "#90205d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M96.272,48.136A48.136,48.136,0,1,0,6.675,72.6L.177,96.094l23.492-6.5a48.145,48.145,0,0,0,72.6-41.461Zm-55.523-11.2H33.363A14.773,14.773,0,1,1,58.1,47.835l-6.276,5.744v5.76H44.443V50.326l8.675-7.941a7.311,7.311,0,0,0,2.4-5.452,7.387,7.387,0,0,0-14.773,0Zm3.693,29.793h7.387v7.387H44.443Zm0,0",
    transform: "translate(-5443.868 8327.75)",
    fill: "#90205d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpSupport);
export default __webpack_public_path__ + "static/media/helpSupport.9c727c21.svg";
export { ForwardRef as ReactComponent };